import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/nejcm/docz-theme-extended/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p><a parentName="p" {...{
        "href": "https://github.com/nejcm/docz-theme-extended"
      }}>{`docz-theme-extended`}</a>{` is an extended
default docz gatsby theme.`}</p>
    <h2 {...{
      "id": "motivation"
    }}>{`Motivation`}</h2>
    <p>{`The default theme is very bare bones. This theme offers some extended
functionality and builds upon the existing UI.`}</p>
    <h2 {...{
      "id": "configuration"
    }}>{`Configuration`}</h2>
    <p>{`This documantation only describes the extended functionality built on top of the default docz theme.`}</p>
    <p>{`For more information about extending and configuring the theme please visit the offical
`}<a parentName="p" {...{
        "href": "https://www.docz.site/"
      }}>{`docz website`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      